export const FOOTER_TEXT = 'Created by Mihir Shah © 2024';
